import { render, staticRenderFns } from "./FloatButton.vue?vue&type=template&id=ef6a92b8&scoped=true&"
import script from "./FloatButton.vue?vue&type=script&lang=js&"
export * from "./FloatButton.vue?vue&type=script&lang=js&"
import style0 from "./FloatButton.vue?vue&type=style&index=0&id=ef6a92b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef6a92b8",
  null
  
)

export default component.exports